import { useAppSelector } from 'shared/lib';

import { selectAllFormFields } from 'entities/creditForm';

export const useAllFormFields = () => {
  return useAppSelector(selectAllFormFields);
};
